// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"BorrowersConfiguration_pageContent__CcQch","footer":"BorrowersConfiguration_footer__356Ox"};